import React, { useEffect, useState } from "react";
import { usersResource } from "../../helpers/configRoutes/backend_helper";
import { Link, useNavigate } from "react-router-dom";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import { userColumns } from "./Columns";
import DataTableElement from "../../components/elements/DataTableElement";

const Team = () => {
    const navigate = useNavigate();

    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: "Delete user",
        loading: false,
        textLoad: "Processing...",
    });

    const [tableLoad, setTableLoad] = useState({
        show: false,
        textLoad: "Loading users...",
    });

    const [filters] = useState({ perPage: 20, page: 1 });
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const getUsers = async () => {
            setTableLoad((prev) => ({ ...prev, show: true }));
            const response = await usersResource("get", { params: filters });
            if (response.status) {
                setUsers(response.users);
            }
            setTableLoad((prev) => ({ ...prev, show: false }));
        };
        getUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteUser = async () => {
        setModalConfirm((prev) => ({ ...prev, loading: true }));
        const response = await usersResource("del", {}, modalConfirm.id);
        if (response.status) {
            const updated = users.filter((u) => u.id !== modalConfirm.id);
            setUsers(updated);
        }
        setModalConfirm({
            show: false,
            title: "Delete user",
            loading: false,
            textLoad: "Processing...",
            id: null,
        });
    };

    const cols = userColumns(navigate, modalConfirm, setModalConfirm);

    return (
        <>
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                    <div>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Team & Users
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage all users with access to your workspace.
                        </p>
                    </div>

                    <div className="flex items-center gap-3">
                        <div className="px-3 py-1.5 rounded-xl bg-cs-bg border border-cs-border text-[11px] text-cs-muted">
                            Total members:{" "}
                            <span className="font-semibold text-cs-dark">
                                {users.length}
                            </span>
                        </div>
                        <Link
                            to="/team-upadd"
                            className="
                inline-flex items-center gap-2
                px-4 py-2.5
                rounded-xl
                bg-cs-primary hover:bg-cs-primary-hover
                text-white text-sm font-medium
                shadow-md hover:shadow-lg
                transition-all
              "
                        >
                            <span className="material-symbols-outlined text-sm">add</span>
                            Add member
                        </Link>
                    </div>
                </div>

                {/* Table wrapper */}
                <div
                    className="
            bg-cs-bg border border-cs-border rounded-2xl
            shadow-sm px-2 py-2
          "
                >
                    <DataTableElement
                        columns={cols}
                        items={users}
                        tableLoad={tableLoad}
                    />
                </div>
            

            <ConfirmDeleteModal
                modal={modalConfirm}
                setModal={setModalConfirm}
                action={deleteUser}
            />
        </>
    );
};

export default Team;
